/**
 * PA 데이터셋 관리 API
 * - 타입이 명시된 파라미터 사용
 * - URLSearchParams를 통한 데이터 전송
 */
export function usePaDatasetApi() {
  return {
    /**
     * 분석 실행 목록 조회
     */
    fetchAnalysisExecList: (findYear: string) => {
      const params = new URLSearchParams();
      params.append('year', findYear);
      return useApi('/api/pa/dataset/getAnalysisExecList.do', {
        method: 'POST',
        body: params.toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
    },

    /**
     * 예측 실행
     */
    executePaAnalysis: (findYear: string, findMonth: string) => {
      const params = new URLSearchParams();
      params.append('year', findYear);
      params.append('month', findMonth);
      return useApi('/api/pa/analysis/executePaAnalysis.do', {
        method: 'POST',
        body: params.toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
    },

    /**
     * 데이터셋 상세 조회 (인덱스 결과 데이터)
     */
    fetchDatasetDetail: (findYear: string, findMonth: string) => {
      const params = new URLSearchParams();
      params.append('year', findYear);
      params.append('month', findMonth);
      return useApi('/api/pa/dataset/getDatasetDetail.do', {
        method: 'POST',
        body: params.toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
    },

    /**
     * 예측 대상 인원수 조회
     */
    fetchPredictionTargetCount: (findYear: string) => {
      const params = new URLSearchParams();
      params.append('year', findYear);
      return useApi('/api/pa/dataset/getPredictionTargetCount.do', {
        method: 'POST',
        body: params.toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
    },
  };
}
